import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { GroupGameComponent } from './components/group-game/group-game.component';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DuelSeriesViewComponent } from './components/duel-series-view/duel-series-view.component';
import { MomentModule } from 'ngx-moment';
import { PlayerCardSmallComponent } from './components/player-card-small/player-card-small.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BracketItemComponent } from './components/bracket-item/bracket-item.component';
import { PlayersComponent } from './components/players/players.component';
import { CreatePlayerModalComponent } from './components/create-player-modal/create-player-modal.component';
import { FullWidthContainerComponent } from './components/full-width-container/full-width-container.component';
import { BracketWrapperComponent } from './components/bracket-wrapper/bracket-wrapper.component';
import { RoundItemComponent } from './components/round-item/round-item.component';
import { RoundEditModalComponent } from './components/round-edit-modal/round-edit-modal.component';
import { VideoLayerComponent } from './components/video-layer/video-layer.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {MatIconModule} from "@angular/material/icon";
import { DuelPlayerDetailsComponent } from './components/duel-player-details/duel-player-details.component';
import { PlayerDuelsModalComponent } from './components/player-duels-modal/player-duels-modal.component';
import {MatTableModule} from "@angular/material/table";
import { PlayersPageComponent } from './components/playersPage/players-page/players-page.component';
import { PlayersPageSearchComponent } from './components/playersPage/players-page-search/players-page-search.component';
import { PlayersPageTableComponent } from './components/playersPage/players-page-table/players-page-table.component';
import { PrivateOfficeComponent } from './components/private-office/private-office.component';
import { AuthorizationModalComponent } from './components/authorization/authorization-modal/authorization-modal.component';
import { AuthorizationComponent } from './components/authorization/authorization.component';
import { DuelAdminMobileComponent } from './components/duel-admin-mobile/duel-admin-mobile.component';
import { DuelResultsMobileComponent } from './components/duel-results-mobile/duel-results-mobile.component';
import { JudgeSearchComponent } from './components/private-office/judge-search/judge-search.component';
import {ValidationErrorComponent} from "./components/validationComponents/validation-error/validation-error.component";
import {MatDialogModule} from "@angular/material/dialog";
import {DuelMobileResultsComponent} from "./components/duel-mobile-results/duel-mobile-results.component";
import { TournamentTunerComponent } from './components/private-office/tournament-tuner/tournament-tuner.component';
import { TournamentTunerGroupsPartComponent } from './components/private-office/tournament-tuner/tournament-tuner-groups-part/tournament-tuner-groups-part.component';
import { TournamentTunerTypeCheckboxesComponent } from './components/private-office/tournament-tuner/tournament-tuner-type-checkboxes/tournament-tuner-type-checkboxes.component';
import { OrdinaryGridTypesListComponent } from './components/private-office/tournament-tuner/ordinary-grid-types-list/ordinary-grid-types-list.component';
import { CrossCloseButtonComponent } from './components/private-office/tournament-tuner/cross-close-button/cross-close-button.component';
import { PlayerReplacerComponent } from './components/player-replacer/player-replacer.component';
import {MatButtonModule} from "@angular/material/button";
import { SetUpGridPlayersManagmentButtonComponent } from './components/set-up-grid-players-managment-button/set-up-grid-players-managment-button.component';
import { SetUpGridPlayersManagementComponent } from './components/set-up-grid-players-management/set-up-grid-players-management.component';
import { PlayerStatsModalContentComponent } from './components/player-stats-modal/player-stats-modal-content/player-stats-modal-content.component';
import { PlayerSummaryComponent } from './components/player-stats-modal/player-summary/player-summary.component';
import { PlayerStatsTableOfDetailsComponent } from './components/player-stats-modal/player-stats-table-of-details/player-stats-table-of-details.component';
import { ManualSetPlayersComponent } from './components/manual-set-players/manual-set-players.component';
import { PlayerDeleteModalComponent } from './components/players/player-delete-modal/player-delete-modal.component';
import { DuelEditOrAddModalComponent } from './components/bracket-item/duel-edit-or-add-modal/duel-edit-or-add-modal.component';
import { TournamentStatusComponent } from './components/tournament-status/tournament-status.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { DrawComponent } from './components/draw/draw.component';
import { PlayerVideoModalComponent } from './components/player-video-modal/player-video-modal.component';
import { RatingsPageComponent } from './components/ratings-page/ratings-page.component';
import { RatingsPageHeaderComponent } from './components/ratings-page/ratings-page-header/ratings-page-header.component';
import { RatingsPageTableComponent } from './components/ratings-page/ratings-page-table/ratings-page-table.component';
import { CustomSelectComponent } from './components/UI/custom-select/custom-select.component';
import { TableAddComponent } from './components/tables/table-add/table-add.component';
import { TableDeleteActivateComponent } from './components/tables/table-delete-activate/table-delete-activate.component';
import { SingleRatingPageComponent } from './components/single-rating-page/single-rating-page.component';
import { PageHeaderComponent } from './components/single-rating-page/page-header/page-header.component';
import { RatingDetailsTableComponent } from './components/single-rating-page/rating-details-table/rating-details-table.component';
import { RatingEditorComponent } from './components/rating-editor/rating-editor.component';
import { RatingEditorFormComponent } from './components/rating-editor/rating-editor-form/rating-editor-form.component';
import { RatingEditorButtonsSectionComponent } from './components/rating-editor/rating-editor-buttons-section/rating-editor-buttons-section.component';
import { RatingEditorBallsDistributionComponent } from './components/rating-editor/rating-editor-balls-distribution/rating-editor-balls-distribution.component';

@NgModule({
    declarations: [
        AppComponent,
        GroupGameComponent,
        DuelSeriesViewComponent,
        PlayerCardSmallComponent,
        BracketItemComponent,
        PlayersComponent,
        CreatePlayerModalComponent,
        FullWidthContainerComponent,
        BracketWrapperComponent,
        RoundItemComponent,
        RoundEditModalComponent,
        VideoLayerComponent,
        DuelPlayerDetailsComponent,
        PlayerDuelsModalComponent,
        PlayersPageComponent,
        PlayersPageSearchComponent,
        PlayersPageTableComponent,
        PrivateOfficeComponent,
        AuthorizationModalComponent,
        AuthorizationComponent,
        DuelAdminMobileComponent,
        DuelResultsMobileComponent,
        JudgeSearchComponent,
        ValidationErrorComponent,
        DuelMobileResultsComponent,
        TournamentTunerComponent,
        TournamentTunerGroupsPartComponent,
        TournamentTunerTypeCheckboxesComponent,
        OrdinaryGridTypesListComponent,
        CrossCloseButtonComponent,
        PlayerReplacerComponent,
        SetUpGridPlayersManagmentButtonComponent,
        SetUpGridPlayersManagementComponent,
        PlayerStatsModalContentComponent,
        PlayerSummaryComponent,
        PlayerStatsTableOfDetailsComponent,
        ManualSetPlayersComponent,
        PlayerDeleteModalComponent,
        DuelEditOrAddModalComponent,
        TournamentStatusComponent,
        ConfirmModalComponent,
        DrawComponent,
        PlayerVideoModalComponent,
        RatingsPageComponent,
        RatingsPageHeaderComponent,
        RatingsPageTableComponent,
        CustomSelectComponent,
        TableAddComponent,
        TableDeleteActivateComponent,
        SingleRatingPageComponent,
        PageHeaderComponent,
        RatingDetailsTableComponent,
        RatingEditorComponent,
        RatingEditorFormComponent,
        RatingEditorButtonsSectionComponent,
        RatingEditorBallsDistributionComponent,
    ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    MomentModule,
    FormsModule,
    ReactiveFormsModule,
    NoopAnimationsModule,
    MatIconModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
  ],
  providers: [NgbActiveModal],
  bootstrap: [AppComponent]
})
export class AppModule { }
